import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wxa-select-icon",
  "use": "icon-wxa-select-icon-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wxa-select-icon\">\n<path d=\"M10.5 15.5H0L17.5 0V8.5C17.5 12.366 14.366 15.5 10.5 15.5Z\" fill=\"#2A75FF\" />\n<path d=\"M8 11.3805L11 13.5L15 8\" stroke=\"white\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol